import { Button } from "wiz-front-shared/components/button/Button";
import { useAtomValue, useSetAtom } from "jotai";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { pushStepAtom } from "store/signUpStore";
import { userStore } from "store/userStore";
import { setTokens, setUserInfo } from "common/auth";
import { requestApp, WEB_TO_APP } from "common/webview";
import './SignUpStep9.css';

// Step9: 회원가입 성공
// 자동 로그인 처리 후 네이티브 앱으로 토큰 전송
export const SignUpStep9 = () => {
    const { t } = useTranslation();
    const pushStep = useSetAtom(pushStepAtom);
    const signupState = useAtomValue(userStore.signup.stateAtom);
    const [isLoggingIn, setIsLoggingIn] = useState(false);

    const handleLogin = () => {
        setIsLoggingIn(true);
        const data = signupState.data;

        if (!data?.accessToken) {
            pushStep(8);
            return;
        }

        // 1. in-memory 토큰 저장 (common/auth.ts)
        setTokens(data.accessToken, data.refreshToken);

        // 2. 사용자 정보 저장
        setUserInfo({
            userId: data.userId,
            email: data.email,
            nickname: data.nickName || data.nickname,
        });

        // 3. 네이티브 앱으로 토큰 + userId + provider 전송
        requestApp(WEB_TO_APP.SEND_TOKEN, {
            access_token: data.accessToken,
            refresh_token: data.refreshToken,
            user_id: data.userId,
            provider: data.provider,
        });
    };

    return (
        <div className="sign-up-step-9" style={{ display: "flex" }}>
            <div className="sign-up-step-9-content">
                <span className="sign-up-step-9-title">{t("signUp.step9.title")}</span>
                <span className="sign-up-step-9-message">
                    {/* 법정대리인 동의 대기 — 로그인은 되지만 보호자 동의 전까지 연결·위치 공유는 제한 */}
                    {signupState.data?.accountStatus === "GUARDIAN_PENDING"
                        ? t("signUp.step9.guardianPending")
                        : t("signUp.step9.message")}
                </span>
            </div>
            <div className="sign-up-bottom-btn">
                <Button
                    text={isLoggingIn ? t("signUp.step9.signingIn") : t("signInText")}
                    onPress={handleLogin}
                    disabled={isLoggingIn}
                />
            </div>
        </div>
    );
};
